import { getSpecialistPosition } from 'src/shared/utils/specialist';
import { rootReducer } from '..';
import { isFilterSet, Specialist, getFilterCount, getSortKey } from '@mindly/ui-components';
import { ISpecialist } from './types';

type RootState = ReturnType<typeof rootReducer>;

export const specialistsSelector = (state: RootState) => state?.specialists?.listData ?? null;

export const psychologistSelectorById = (id: string) => {
  return (state: RootState) => {
    return (state?.specialists?.listData?.find((elem) => elem?.id === id || elem?.slug === id) ??
      state?.specialists?.backup?.listData?.find((elem) => elem?.id === id || elem?.slug === id) ??
      state.usersPsychologists?.find((elem) => elem?.id === id || elem?.slug === id) ??
      state?.loadedSpecialists?.data?.find((elem) => elem?.id === id || elem?.slug === id) ??
      state?.favouriteSpecialists?.data?.find((elem) => elem?.id === id || elem?.slug === id) ??
      null) as ISpecialist;
  };
};

export const specialistSelectorPositionById = (id: string) => {
  return (state: RootState) => {
    return getSpecialistPosition(id, (state?.specialists?.listData as unknown as Specialist[]) || []);
  };
};

export const loadedSpecialistsSelector = (id: string) => (state: RootState) =>
  state?.loadedSpecialists?.data?.find((elem) => elem?.id === id || elem?.slug === id) ?? null;

export const specilistLoadingSelector = (state: RootState) => state?.specialists?.loading ?? 'idle';

export const isPaginationDisabledSelector = (state: RootState) => state?.specialists?.isPaginationDisabled ?? false;

export const isLoadingSpecialistByIDSelector = (state: RootState) => {
  return state?.specialists?.loading === 'pending' || state?.loadedSpecialists?.loading === 'pending';
};

export const specialistsFiltersValuesSelector = (state: RootState) => state?.specialists?.filters.values;
export const specialistsFiltersLoadingSelector = (state: RootState) => state?.specialists?.filters.loading;
export const specialistsFiltersItemsSelector = (state: RootState) => state?.specialists?.filters.items;
export const specialistsFiltersIsSetSelector = (state: RootState) => isFilterSet(state.specialists.filters.values);
export const specialistsFiltersCountSelector = (state: RootState) => getFilterCount(state.specialists.filters.values);
export const specialistsTotalItemsSelector = (state: RootState) => state?.specialists?.filters.totalItems;

export const specialistsBackupListSelector = (state: RootState) => state?.specialists?.backup?.listData;
export const specialistsBackupLoadingSelector = (state: RootState) =>
  ['idle', 'pending'].includes(state?.specialists?.backup?.loading);
export const specilistTotalSelector = (state: RootState) => state?.specialists?.total ?? 0;
export const specialistsSortKeySelector = (state: RootState) =>
  getSortKey(state?.specialists?.sort.value, state?.specialists?.sort.direction);

export const specialistsGoalsSelector = (state: RootState) => state?.specialists?.goals ?? [];
